// src/utils/migrateData.js
import { collection, getDocs, doc, writeBatch } from 'firebase/firestore';
import { db } from '../services/firebase/config';

export const migratePortfolioData = async (userEmail) => {
  try {
    // Portfolio targets verilerini oku
    const targetSnapshot = await getDocs(collection(db, 'portfolio_targets'));
    
    if (targetSnapshot.empty) {
      console.log('portfolio_targets koleksiyonu boş');
      return true;
    }

    const batch = writeBatch(db);
    let operationCount = 0;

    // Hedef koleksiyona yazmak için batch işlemi hazırla
    targetSnapshot.forEach((document) => {
      const newDocRef = doc(collection(db, 'users', userEmail, 'portfolio'), document.id);
      batch.set(newDocRef, {
        ...document.data(),
        lastModifiedBy: userEmail,
        updatedAt: new Date()
      });
      operationCount++;
    });

    // Batch işlemini gerçekleştir
    if (operationCount > 0) {
      await batch.commit();
      console.log(`${operationCount} portfolio verisi ${userEmail} için taşındı`);
    }

    return true;
  } catch (error) {
    console.error('Portfolio migration error:', error);
    throw new Error('Portfolio verisi taşınırken hata oluştu: ' + error.message);
  }
};

export const migratePositions = async (userEmail) => {
  try {
    // Pozisyon verilerini oku
    const positionsSnapshot = await getDocs(collection(db, 'current_positions'));
    
    if (positionsSnapshot.empty) {
      console.log('current_positions koleksiyonu boş');
      return true;
    }

    const batch = writeBatch(db);
    let operationCount = 0;

    // Hedef koleksiyona yazmak için batch işlemi hazırla
    positionsSnapshot.forEach((document) => {
      const newDocRef = doc(collection(db, 'users', userEmail, 'positions'), document.id);
      batch.set(newDocRef, {
        ...document.data(),
        lastModifiedBy: userEmail,
        updatedAt: new Date()
      });
      operationCount++;
    });

    // Batch işlemini gerçekleştir
    if (operationCount > 0) {
      await batch.commit();
      console.log(`${operationCount} pozisyon verisi ${userEmail} için taşındı`);
    }

    return true;
  } catch (error) {
    console.error('Positions migration error:', error);
    throw new Error('Pozisyon verisi taşınırken hata oluştu: ' + error.message);
  }
};